// ----------------------------------------------------------------------

export default function LoadingButton() {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        loadingIndicator: {
          color: '#ffffff'
        }
      }
    }
  };
}
